import { BellCogIcon } from './BellCogIcon';

/**
 * author: Colton Wiscombe
 * id 8191437C-298C-4A5F-8EC3-A2DA4584BF0D
 * name bell-cog
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-cog.svg
 * tags
 * - Notification 
 * - Settings 
 */
export const BellSettingsIcon = BellCogIcon;
export default BellSettingsIcon